import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import EmptyStateVideo from './components/Video';
import UnlockButton from './components/UnlockButton';
import LearnMoreLink from './components/LearnMoreLink';

import { userHasFeature } from '../../helpers/Features';

const EmptyCustomRoles = ({ link }) => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Custom user permissions made just for you' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({ defaultMessage: 'Create custom roles that work for your team. Decide who can download, upload, share, edit, and more!' })}
        </div>
        <div>
          {userHasFeature('custom-roles') ? (
            <Button color="primary" className="mt-4" tag={Link} to={link}>
              {intl.formatMessage({ defaultMessage: 'Create a Custom Role' })}
            </Button>
          ) : (
            <UnlockButton feature="custom-roles" />
          )}
          <LearnMoreLink url="https://help.stockpress.co/en/articles/5937840-creating-custom-roles" />
        </div>
      </Col>
      <EmptyStateVideo video="custom-roles" />
    </div>
  );
};

EmptyCustomRoles.propTypes = {
  link: PropTypes.string,
};

EmptyCustomRoles.defaultProps = {
  link: null,
};

export default EmptyCustomRoles;
